export const API_HEADER = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};
export const API_URL = "https://api.excel.rootiy.kr" // location.origin
export function toCommaedNumber(val) {
    //                         NLB . 뒤에 있지않은
    //                         |         | 결과에 포함X
    //                         |         |          | 뒤에 따라오지않음
    return (val+"").replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
}
